<template lang="es">
    <v-container fluid>
        <!-- Listado de recetas -->
        <ComponenteCrud
            titulo="Listado de recetas"
            :datos=elementos
            tipo="receta"
            @eliminar="eliminar"  
            @editar="editar"  
            @nuevo="nuevo_formulario"
        ></ComponenteCrud>
    </v-container>
</template>
<script>

import ComponenteCrud from '@/components/modulos/ComponenteCrud.vue'
import { mapActions, mapState } from "vuex";

export default {
    components:{
        ComponenteCrud
    },
    data() {
        return {
            item_editando:{},
            nuevo:false,
            editando:false,
           
         
        }
    },

    computed: {
        ...mapState(['recetas']),
        modo(){return !this.nuevo?'editar':''},
        formulario(){
            return this.nuevo || this.editando
        },
        elementos(){
            return {
                items:this.recetas,
                headers:[
                    {text: "Id", value: "id_receta",align: 'center'},
                    {text: "Nombre", value: "name", align: 'center', width: '40%'},
                    {text: "Tipo", value: "nombre_tipo_tratamiento", align: 'center', width: '30%'},
                    {text: "Acción", value: "action", align: 'center'},
                ],
            }
        }
    
    },

    methods: {
        // ...mapActions('api',['getTiposTratamiento','postTipoTratamiento','putTipoTratamiento','deleteTipoTratamiento']),
        ...mapActions('api',['getRecetas','postReceta','putReceta','deleteReceta','putTipoTratamiento','deleteTipoTratamiento']),
        nuevo_formulario(){
            this.$emit('nuevo')
        },
        async submit(payload){
            const user =  JSON.parse(localStorage.getItem('user'))
            console.log(user)
            payload.id_usuario = user.id
           
            console.log(payload);
            if (this.nuevo==true){
                console.log("Debo llamar al backend para hacer el post",payload)
                // await this.postTipoTratamiento(payload)
                await this.postReceta(payload)
                this.nuevo=false;
            }else{
                this.editando=false;
                this.tipo_tratamiento_editando={};

                // await this.putTipoTratamiento(payload)
                const recet = await this.putReceta(payload)
                console.log(recet);
                console.log("YA HE HECHO EL PUT");
            }
            await this.get_recetas();
            console.log("YA ESTAN TODAS LAS RECETAS");
        },
        editar(item){
            this.$emit('editar', item)
            //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
        },
        async eliminar(item){
            this.$emit('eliminar', item)
            //llama a la accion de abrir formulario pasandole como parametro el item que queremos editar
        },
        cancel(){
            this.editando=false;
            this.nuevo=false;
        }

    },


    // mounted() {
    //     this.get_recetas();
    // },
}
</script>
<style lang="">
    
</style>